var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"promo-banner",class:{ empty: !_vm.game.promotionBarImage }},[(_vm.game.promotionBarImage)?_c('div',{staticClass:"banner",class:{ clickable: _vm.game.promotionBarLink },style:({ backgroundImage: `url(${_vm.cdnHost}${_vm.getLocaleString(_vm.game.promotionBarImage)})` }),on:{"click":_vm.promoClick}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }